/* custom-ui-modal-utils.tsx generated by @compiled/babel-plugin v0.36.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "./custom-ui-modal-utils.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ModalBody } from '@atlaskit/modal-dialog';
import { N0 } from '@atlaskit/theme/colors';
var smallModalStyles = null;
var mediumModalStyles = null;
var largeModalStyles = null;
var xlargeModalStyles = null;
var maxModalStyles = null;
var resizableModalStyles = null;

// TODO: Fix below styles once we move to compiled/react
export var ModalContentWrapper = function ModalContentWrapper(_ref) {
  var children = _ref.children,
    size = _ref.size,
    styles = _ref.styles,
    isResizable = _ref.isResizable;
  switch (size) {
    case 'small':
      return /*#__PURE__*/React.createElement("div", {
        className: ax(["_2rko1sit _4t3i1tmh _1tkenklw _bfhk13b4", isResizable && "_1reo1wug _18m91wug _4t3i1wug"]),
        style: _objectSpread(_objectSpread({}, styles), {}, {
          "--_1f6rtr1": ix("var(--ds-surface-overlay, ".concat(N0, ")"))
        })
      }, children);
    case 'medium':
      return /*#__PURE__*/React.createElement("div", {
        className: ax(["_2rko1sit _4t3ivzbd _1tke1lk4 _bfhk13b4", isResizable && "_1reo1wug _18m91wug _4t3i1wug"]),
        style: _objectSpread(_objectSpread({}, styles), {}, {
          "--_1f6rtr1": ix("var(--ds-surface-overlay, ".concat(N0, ")"))
        })
      }, children);
    case 'large':
      return /*#__PURE__*/React.createElement("div", {
        className: ax(["_2rko1sit _4t3i1rxh _1tke1yw0 _bfhk13b4", isResizable && "_1reo1wug _18m91wug _4t3i1wug"]),
        style: _objectSpread(_objectSpread({}, styles), {}, {
          "--_1f6rtr1": ix("var(--ds-surface-overlay, ".concat(N0, ")"))
        })
      }, children);
    case 'xlarge':
      return /*#__PURE__*/React.createElement("div", {
        className: ax(["_2rko1sit _4t3i10fc _1tkezwhf _bfhk13b4", isResizable && "_1reo1wug _18m91wug _4t3i1wug"]),
        style: _objectSpread(_objectSpread({}, styles), {}, {
          "--_1f6rtr1": ix("var(--ds-surface-overlay, ".concat(N0, ")"))
        })
      }, children);
    case 'max':
      return /*#__PURE__*/React.createElement("div", {
        className: ax(["_2rko1sit _4t3i1osq _bfhk13b4"]),
        style: _objectSpread(_objectSpread({}, styles), {}, {
          "--_1f6rtr1": ix("var(--ds-surface-overlay, ".concat(N0, ")"))
        })
      }, children);
    default:
      return /*#__PURE__*/React.createElement(ModalBody, null, children);
  }
};
export var getAtlasKitModalWidth = function getAtlasKitModalWidth(modalSize) {
  if (modalSize === 'xlarge') {
    return 'x-large';
  }
  if (modalSize === 'max') {
    return '100%';
  }
  return modalSize;
};